import fetch from '../utils/fetch';
import { giftCodeURL } from 'endpoints';
import * as Promise from 'bluebird';
class GiftCodeSDK {

    getAward = ( awardId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/awards/${ awardId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( award ) => {
                        resolve( award );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    saveAward = ( award ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/awards`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( award )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( award ) => {
                        resolve( award );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data ) );
                        alert( data[ 0 ].message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    saveLevels = ( reqObj ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/levels`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( reqObj )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( levels ) => {
                        resolve( levels );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    deleteLevel = ( { awardId, levelCode, countryCode } ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/levels/${ encodeURIComponent( awardId ) }/${ encodeURIComponent( levelCode ) }/${ encodeURIComponent( countryCode ) }`, {
                method: 'DELETE'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( () => {
                        resolve();
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getAwardCountries = ( awardId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/awards/${ awardId }/countries` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( countries ) => {
                        resolve( countries );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    saveAwardCountries = ( awardId, countries ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/awards/${ awardId }/countries`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( countries )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( countries ) => {
                        resolve( countries );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getAwardLevels = async ( awardId ) => {
        const countries = await this.getAwardCountries( awardId );
        const allLevels = [];
        await Promise.map(
            countries, async ( country ) => {
                const levels = await this.getProgramLevels( country.programNumber );
                levels.map( ( level ) => {
                    allLevels.push( {
                        countryCode: country.countryCode,
                        ...level
                    } );
                } );
            }, { concurrency: 5 } );

        return allLevels;
    };

    getProgram = ( programNumber ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/programs/${ programNumber }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( program ) => {
                        resolve( program );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getProgramLevels = ( programNumber ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/programs/${ programNumber }/levels` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( levels ) => {
                        resolve( levels );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getGiftCode = ( giftCodeId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/gift-codes/${ giftCodeId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( giftCode ) => {
                        resolve( giftCode );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    cancelGiftCode = ( giftCodeId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ giftCodeURL }/gift-codes`, {
                method: 'PATCH',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( {
                    pid: '',
                    giftCodeIds: [ giftCodeId ],
                    action: 'cancel',
                    status: 'Cancelled',
                    statusUpdatedAt: new Date()
                } )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( giftCode ) => {
                        resolve( giftCode );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getWebappUrl = ( identifierList ) => {
        if ( Array.isArray( identifierList ) ) {
            return identifierList.find( ( id ) =>
                ( id || '' ).toLowerCase().indexOf( 'myawardcode.com' ) >= 0 );
        } else {
            return '';
        }
    };

    getGiftCodeUrl = ( identifierList, giftCodeId ) => {
        if ( giftCodeId ) {
            return `${ this.getWebappUrl( identifierList ) }/${ giftCodeId }`;
        } else {
            return '';
        }
    };

    getProductsUrl( identifierList, browseCode ) {
        if ( browseCode ) {
            return `${ this.getWebappUrl( identifierList ) }/products/${ browseCode }`;
        } else {
            return '';
        }
    }
}

export default new GiftCodeSDK();
